import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/global.css';
import './styles/theme.css';
import './styles/components.css';
import './styles/enhanced-node-interactions.css';

// Initialize the React application
const root = createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Enable HMR for development
if (import.meta.hot) {
  import.meta.hot.accept();
}
